/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionTrainingFlagsModel } from '../../models/vision-training-flags-model';

export interface AdminOrganizationOrganizationIdVisionFlagsPut$Params {
  organizationId: string;
      body?: VisionTrainingFlagsModel
}

export function adminOrganizationOrganizationIdVisionFlagsPut(http: HttpClient, rootUrl: string, params: AdminOrganizationOrganizationIdVisionFlagsPut$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>> {
  const rb = new RequestBuilder(rootUrl, adminOrganizationOrganizationIdVisionFlagsPut.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>;
    })
  );
}

adminOrganizationOrganizationIdVisionFlagsPut.PATH = '/Admin/Organization/{organizationId}/VisionFlags';
